import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import _Switch from "../../generic/_Switch";
import { classNames } from "../../../utils/helpers";
import PropTypes from "prop-types";
import { useAuth } from "../../../Context/AuthContext";
import Icon from "../../Icon";
const ChannelSend = ({ step }) => {
  const { values, setFieldValue } = useFormikContext();
  const auth = useAuth();
  let channels = auth.getUserChannel();
  const { isRcs, isSms, isWhatsapp, isEmail } = values;
  const mapIcons = {
    SMS: "sms",
    RCS: "chat_bubble",
    Whatsapp: "Whatsapp",
    Email: "email",
  };

  const channelArray = [
    {
      id: "isSms",
      name: "SMS",
      description: "Mensaje SMS",
      value: isSms,
    },
    {
      id: "isRcs",
      name: "RCS",
      description: "Mensaje RCS",
      value: isRcs,
    },
    {
      id: "isWhatsapp",
      name: "Whatsapp",
      description: "Mensaje WhatsApp",
      value: isWhatsapp,
    },
    {
      id: "isEmail",
      name: "Email",
      description: "Mensaje Email",
      value: isEmail,
    },
  ];

  const channelFiltered = useMemo(() => {
    if (channels.includes("ALL")) {
      return channelArray;
    }

    return channelArray.filter((item) =>
      channels.includes(item.name.toUpperCase())
    );
  }, [channels]);

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="flex items-end gap-2 my-2">
        <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
          <span className="font-bold">{step}</span>
        </div>
        <div className="text-xl font-bold text-gray-600">Seleccionar Canal</div>
      </div>

      <div className="flex flex-col gap-2">
        {channelFiltered.map((item, index) => (
          <div
            key={index}
            className={classNames(
              "flex items-center justify-between p-4 rounded-lg transition-colors bg-gray-100"
            )}
          >
            <div className="flex items-center gap-3">
              <div
                className={classNames(
                  "w-10 h-10 rounded-3xl text-white flex items-center justify-center font-semibold",
                  {
                    "bg-cyan-600": item.id === "isSms",
                    "bg-purple-600": item.id === "isRcs",
                    "bg-green-600": item.id === "isWhatsapp",
                    "bg-yellow-600": item.id === "isEmail",
                  }
                )}
              >
                <Icon icon={mapIcons[item.name]} className={"text-white"} />
              </div>
              <div className="flex flex-col">
                <div className="font-semibold text-slate-900">{item.name}</div>
                <div className="text-xs text-slate-600">{item.description}</div>
              </div>
            </div>
            <_Switch
              value={item.value}
              onChange={(value) => setFieldValue(item.id, value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

ChannelSend.propTypes = {
  step: PropTypes.number,
};

export default ChannelSend;
